import { IState } from 'typescript/interfaces/companies'
import { IUserPage } from 'typescript/interfaces/users'
import { IExportParams } from './export'
import { IPagination } from './pagination'

export interface IVendorInitValues {
  ein: string
  vendorType: string
  comments: string
  phone: string
  email: string
  nameOnCheck: string
  userPage: IUserPage
  businessName: string
  city: string
  street: string
  zipCode: string
  federalTaxId: string
  stateId: number | ''
}

export enum SortVendorFields {
  id = 'Id',
  name = 'Name',
  ein = 'Ein',
  phone = 'Phone',
  address = 'Address',
  vendorType = 'VendorType',
  startingBalance = 'StartingBalance',
  availableBalance = 'AvailableBalance',
  lastTransactions = 'LastTransactions',
}

export interface IUploadedVendorDocuments {
  W9: IVendorDocumentConnectParamsResponse[]
  Invoice: IVendorDocumentConnectParamsResponse[]
}

export type IUploadedVendorCategoriesKeys = keyof IUploadedVendorDocuments

export interface IVendorDocument {
  id: number
  documentUrl: string
  description: string
  createdDate: string
  documentType: IUploadedVendorCategoriesKeys
}

export interface IUploadVendorDocWithDocType {
  file: File
  documentType: IUploadedVendorCategoriesKeys
}

export interface IVendorDocumentConnectParams {
  documentUrl: string
  description: string
  vendorId: number
  documentType: IUploadedVendorCategoriesKeys
}

export interface IVendorDocumentConnectParamsResponse {
  id: number
  documentUrl: string
  description: string
  createdDate: string
  documentType: IUploadedVendorCategoriesKeys
}

export interface IVendorDocuments {
  W9: File[]
  Invoice: File[]
}

export interface IInitVendorDocsValues {
  documents: IVendorDocuments
  uploadedDocuments: IUploadedVendorDocuments
}

export interface IVendorDocumentToSend {
  file: File
  documentType: IUploadedVendorCategoriesKeys
}

export interface IVendorEntity {
  id: number
  name: string
  ein: string
  vendorType: string
  comments: string
  phone: string
  email: string
  nameOnCheck: string
  userPage: Required<IUserPage>
  businessName: string
  city: string
  street: string
  zipCode: string
  federalTaxId: string
  state: IState
  documents: IVendorDocument[]
}

export interface IVendorListItem {
  id: number
  name: string
  ein: string
  vendorType: string
  comments: string
  businessName: string
  lastTransactions: string
  phone: string
  federalTaxId: string
  street: string
  city: string
  zipCode: string
  state: IState
  userPage: IUserPage
}

export interface IVendorListLightItem {
  id: number
  name: string
}

export interface IVendorExportParams extends IExportParams {
  Criteria: IPagination<SortVendorFields>
}

export enum VendorType {
  Vendor = 'RECOVERY - VENDOR',
  Attorney = 'RECOVERY - ATTORNEY',
  CollectionAgency = 'RECOVERY - COLLECTION AGENCY',
}
